import { NavigationConfiguration, RouteConfig } from '@/types';

export class NavigationManager {
	getLabel(route: RouteConfig, navigationConfiguration: NavigationConfiguration): string {
		if (this.hasConfigurationForRoute(route, navigationConfiguration)) {
			return navigationConfiguration[route.meta?.navigationConfigurationName].name;
		}

		return route.meta?.label;
	}

	getSubLabel(route: RouteConfig, navigationConfiguration: NavigationConfiguration): string {
		if (this.hasConfigurationForRoute(route, navigationConfiguration)) {
			return navigationConfiguration[route.meta?.navigationConfigurationName].subName;
		}

		return route.meta?.subLabel;
	}

	getOrderProperty(route: RouteConfig, navigationConfiguration: NavigationConfiguration): number {
		if (this.hasConfigurationForRoute(route, navigationConfiguration)) {
			return navigationConfiguration[route.meta?.navigationConfigurationName].orderProperty || 999;
		}

		if (route.meta) {
			return route.meta.orderProperty || 999;
		}

		return 999;
	}

	getSupportLink(route: RouteConfig, navigationConfiguration: NavigationConfiguration): string | undefined {
		if (this.hasConfigurationForRoute(route, navigationConfiguration)) {
			return navigationConfiguration[route.meta?.navigationConfigurationName].supportLinkUrl;
		}

		return route.meta?.supportLinkUrl;
	}

	getSupportLinkLabel(route: RouteConfig, navigationConfiguration: NavigationConfiguration): string | undefined {
		if (this.hasConfigurationForRoute(route, navigationConfiguration)) {
			return navigationConfiguration[route.meta?.navigationConfigurationName].supportLinkLabel;
		}

		return route.meta?.supportLinkLabel;
	}

	hasConfigurationForRoute(route: RouteConfig, navigationConfiguration: NavigationConfiguration): boolean | undefined {
		return route.meta &&
			!!route.meta.navigationConfigurationName &&
			!!navigationConfiguration[route.meta.navigationConfigurationName];
	}

	hasMandatoryConfiguration(route: RouteConfig): boolean {
		return route.meta && route.meta.isConfigurationMandatory;
	}
}
